import { render } from "./ConfirmSizeRadio.vue?vue&type=template&id=6e32afce"
import script from "./ConfirmSizeRadio.vue?vue&type=script&lang=js"
export * from "./ConfirmSizeRadio.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__